String.prototype.capitalizeFirstLetter = function capitalizeFirstLetter() {
  return this.charAt(0).toUpperCase() + this.substr(1);
};

Array.prototype.findAndRemove = function (callback) {
  let i = 0;

  while (i < this.length) {
    if (callback(this[i], i)) {
      this.splice(i, 1);
    } else {
      ++i;
    }
  }
  return this;
};

String.prototype.slugify = function () {
  return this.toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
    .trim();
};
